import { render, staticRenderFns } from "./Confirmation2.vue?vue&type=template&id=0e208fcb&scoped=true&"
import script from "./Confirmation2.vue?vue&type=script&lang=js&"
export * from "./Confirmation2.vue?vue&type=script&lang=js&"
import style0 from "./Confirmation2.vue?vue&type=style&index=0&id=0e208fcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e208fcb",
  null
  
)

export default component.exports